import React from 'react';
import { ButtonModalValueProps, ChipProps, ChipValueProps } from 'spindl-shared-components';
import { UserAccount, UserAccountListCombinedProps } from '../../blocks/UserAccountList/types';

export type UserListPageClasses = {
  userAccountList?: string;
  buttonModal?: string;
};

export type UserListPageValueProps = {
  userAccountList?: UserAccountListCombinedProps;
  buttonModal?: ButtonModalValueProps;
  setSelectedAccount?: (account?: UserAccount) => void;
  setShow?: (show: boolean) => void;
  setModalType?: (modalType: ModalTypeEnum) => void;
  selectedAccount?: UserAccount;
  setChipProps?: (props: ChipProps & ChipValueProps) => void;
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
};

export type UserListPageProps = {
  className?: string;
  classes?: UserListPageClasses;
};

export enum ModalTypeEnum {
  ChangeRole,
  ResetPassword,
  DisableUser,
  EmailUpdate,
}

export type UserListPageCombinedProps = UserListPageValueProps & UserListPageProps;
